import React from "react";
import { Form, Field } from 'react-final-form'
import PropTypes from "prop-types";
import InputField from "../fields/InputField";
import {composeValidators, required, minLength, limit} from "../../helpers/ValidateHelper";
import Error from "../fields/Error";

function ResetPasswordNewPasswordForm({onSubmit}) {
    return <Form onSubmit={onSubmit}>
        {({handleSubmit, submitting, values}) => (
            <form id="reset-password-active-form" onSubmit={handleSubmit} className="form-validation">
                <div className="form-group">
                    <div className="form-label">New Password <span className="rq">*</span></div>
                    <Field
                        name="newPassword"
                        type="password"
                        component={InputField}
                        placeholder="Enter new password"
                        className="control-input"
                        autoComplete="new-password"
                        validate={composeValidators(
                            required('Please enter a new password'),
                            minLength('Password must be at least {min} characters', 5),
                            limit('Maximum {limit} characters allowed. You\'ve used {count}.', 255)
                        )}
                    />
                    <Error name="newPassword" />
                </div>
                <div className="form-group">
                    <div className="form-label">Confirm Password <span className="rq">*</span></div>
                    <Field
                        name="confirmPassword"
                        type="password"
                        component={InputField}
                        placeholder="Confirm new password"
                        className="control-input"
                        autoComplete="new-password"
                        validate={composeValidators(
                            required('Please confirm your password'),
                            value => value && values.newPassword && value !== values.newPassword
                                ? 'Passwords do not match' : undefined
                        )}
                    />
                    <Error name="confirmPassword" />
                </div>
                <div className="form-btn_v3">
                    <button className="btn_v3 btn_v3-md btn_v3-primary" disabled={submitting}>
                        {submitting ? 'Saving...' : 'Set New Password'}
                    </button>
                </div>
            </form>
        )}
    </Form>
}

ResetPasswordNewPasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
}

export default ResetPasswordNewPasswordForm;
